import { defineSchema } from '../../schema-meta.ts';
import { registerSchema } from '../../generic-codec.ts';

export const StageWaveShopItemGroupSchema = defineSchema({
  name: 'stageWaveShopItemGroup',
  fields: [
    ['itemId', 'number'],
    ['silverPriceMin', 'number'],
    ['silverPriceMax', 'number'],
    ['weight', 'number'],
  ],
});

registerSchema(StageWaveShopItemGroupSchema);
